import React from 'react';
const Footer=()=>{
    return (
       <div className='foot'>
       <h5 className='foot-component'>© 2023 Copyright: TravelBook.com</h5>
       </div> 
      );
}
export default Footer;